// src/components/KPIStrip.tsx
import React from 'react';
import { KPICard } from './KPICard';

export interface KPICardData {
  id: string;
  label: string;
  value: string | number;
  subline: string;
  sparklineData?: number[];
  state: 'normal' | 'critical' | 'ok';
}

interface KPIStripProps {
  cards: KPICardData[];
  className?: string;
}

export const KPIStrip: React.FC<KPIStripProps> = ({ cards, className = '' }) => {
  return (
    <div 
      className={className}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px',
        marginBottom: '20px',
      }}
    >
      {cards.map((card, index) => (
        <div 
          key={card.id} 
          className={`animate-fade-in-up stagger-${Math.min(index + 1, 6)}`}
          style={{ animationFillMode: 'both' }}
        >
          <KPICard {...card} />
        </div>
      ))}
    </div>
  );
};

export default KPIStrip;
